<template>
  <div>
    <div class="main" style="margin-top: 5px;">
      <el-col :span="24" style="height: 330px;">
        <div class="container container_col" id="app">
          <div class="n-left-nav" style="width: 200px;">
            <div class="navTitle">
              互动交流
            </div>
            <div class="m-nav-list" style="width: 160px;">
              <div class="typeNav">
                <div :class="{activeSelectType : activeSelect=='1'}" @click="selectedActive('1')" class="typeNav activeSelect">留言列表</div>
              </div>
              <div  class="typeNav">
                <div :class="{activeSelectType : activeSelect=='2'}" @click="selectedActive('2')" class="typeNav ">发布留言</div>
              </div>
            </div>
          </div>
         <div class="page-right" style="width: 980px;border: 1px solid #e4e4e4;margin-top: 20px;margin-right: 20px">
            <div class="pagelujing">
                <div class="name">&nbsp;互动交流</div>
              </div>
               <div class="news-txt ny mg-t-b">
                 <div class="news-con">
                   <!-- <ul class="newslist ny">
          							<li  v-for="(new1, index) in news" @click="jump(new1.id)" style="cursor: pointer;"><a > {{new1.title}}</a><span>{{new1.createTime}}</span></li>
          						</ul> -->

                   <div v-if="activeSelect==1" style="font-size: 14px;line-height: 26px;">
                        <div style="width: 98%;margin-left: 1%;height: auto;overflow: hidden;border-top: 1px solid #ccc;">
          	   <div style="width: 100%;min-height: 60px;border-bottom: 1px solid #ccc;" v-for="(item,index) in leaveWords">

          		   <div style="width: 96%;min-height: 40px;line-height: 40px;margin-left: 2%;">
          		   			   {{item.content}}
          		   </div>
          		   <div style="width: 48%;height: 15px;line-height: 15px;text-align: left;margin-left: 2%;float: left;">
          		   			   {{item.title}}
          		   </div>
          		   <div style="width: 48%;height: 15px;line-height: 15px;text-align: right;margin-left: 2%;float: left;">
          		   			   {{item.createTime}}
          		   </div>
          	   </div>

            </div>

          <div class="tabListPage">
                   <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
                     :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                     :total="totalCount">
                   </el-pagination>
                 </div>

                   </div>
                   <div v-if="activeSelect==2" style="font-size: 14px;line-height: 26px;">
                     <span style="display:block;text-indent:2em;color: #555;">农村产权交易所的发展离不开您的智慧和贡献，如果您对农村产权交易所的建设和发展有什么好的建议和意见，
                       请给我们来信。请务必提供您的正确邮箱地址。信息提交完成后需要等待管理员处理，没有按要求正确填写信息的将不予发布。</span>


          		  <div class="answers">
          		    <el-form :model="leaveWord" :rules="answersRules" ref="answersRef" label-width="100px"
          		      class="demo-ruleForm">
          		      <el-form-item label="留言主题" prop="name">
          		        <el-input v-model="leaveWord.title" size="medium"></el-input>
          		      </el-form-item>

          		      <el-form-item label="手机号" prop="phone">
          		        <el-input v-model="leaveWord.phone" size="medium"></el-input>
          		      </el-form-item>
          		      <el-form-item label="内容" prop="content">
          		        <el-input type="textarea" v-model="leaveWord.content" size="medium"></el-input>
          		      </el-form-item>
          		    </el-form>
          		    <div style="text-align: center;">
          		      <el-button type="primary" @click="saveLeaveWord()">提交</el-button>
          		    </div>
          			  </div>

          		  </div>


                   <div class="tcdPageCode"></div>
                 </div>
               </div>

             </div>
        </div>
      </el-col>


    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
       unitCode:"410825000000",//"410825000000",
       leaveWords: [],
       pageNum: 1, // 默认显示第几页
       totalCount: 0, // 总条数，根据接口获取数据长度(注意：这里不能为空)
       pageSizes: [5, 10, 15, 20], // 个数选择器（可修改）
       pageSize: 10, // 默认每页显示的条数（可修改）
       type: "",
       activeSelect:1,
       typeName: "",
       leaveWord: {
       			unitCode:"410825000000",
         title: "",
         phone: "",
         content: "",
      },

   answersRules:{
       name:[
       { required: true, message: '请输入姓名', trigger: 'blur' },
       ],
       phone:[
       { required: true, message: '请输入手机号', trigger: 'blur' },
       { min: 11, max: 11, message: '长度在 11 位的手机号', trigger: 'blur' }
       ]
     }
 }
   },
   mounted() {
     this.getWords();
   },
   methods: {


     async getWords() {

       // this.type=='1'?this.typeName="通知公告":this.typeName="处置公告";
       if (this.type == 1) {
         this.typeName = "互动问答";
       } else if (this.type == 2) {
         this.typeName = "常见问题";
       }

       const action = "/web/leave/list?unitCode="+this.unitCode+"&pageNum=" + this.pageNum + "&pageSize=" + this.pageSize;
       const {
         data: res
       } = await  this.$http.get(action);
       this.leaveWords = res.data.list;
       this.totalCount = res.data.total;
       console.log(res)
     },
     saveLeaveWord(){
   	  this.$http.post("/web/leave/add", this.leaveWord).then((res) => {
   		  alert("留言发布成功");
   		  this.getWords();
   	  });
     },

     selectedActive(type) {
      this.activeSelect = type;
     },
     jump(id) {
       window.location.href = "noticeDetail.html?type=" + this.type + "&id=" + id;
     },
     handleSizeChange(val) { // 每页显示的条数，选择每页条数的时候执行
       console.log("handleSizeChange")
       this.pageSize = val // 改变每页显示的条数
       this.getWords() // 点击每页显示的条数时，显示第一页
       this.pageNum = 1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
     },
     // 显示第几页
     handleCurrentChange(val) {
       this.pageNum = val; // 改变默认的页数
       this.getWords() // 切换页码时，要获取每页显示的条数
     },
     handleClose(done) {
       done();
     },


    }



  };
</script>

<style scoped="">
  @import url("../../../assets/css/index.css");
  @import url("../../../assets/css/base.css");
  @import url("../../../assets/css/main.css");
  @import url("../../../assets/css/news.css");

  .per {
    width: 98%;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #9796a72e;
    cursor: pointer;
  }

  .typeNav {
    width: 200px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    cursor: pointer;
    border-bottom: 1px solid #f6f6f6;
  }

  .navTitle {
    border-bottom: 1px solid #f6f6f6;
    text-align: center;
    height: 50px;
    line-height: 50px;
    width: 200px;
    background-color: #f6f6f6;
    font-size: 20px;

  }

  .activeSelectType {
    background-color: #4cb050;
    color: white;
  }

  .hone-container {
    height: 100%;
  }

  a-layout-content {
    height: 100%;
  }

  .ant-layout-header {
    /* 2850A0 */
    padding: 0px;
    background-color: #3c8dbc !important;
  }

  .main {
    width: 1220px;
    margin: 0 auto;
    height: auto;
    overflow: hidden;
    background-color: white;
    margin-top: 5px;
  }
</style>
